import { useEffect, useState } from 'react';

interface IUseIntersectionProps {
  ref: any,
  once?: boolean,
}
interface IUseIntersection {
  isHasView: boolean
  isIntersecting: boolean
}

const useIntersection = ({ ref }: IUseIntersectionProps): IUseIntersection => {
  const [isIntersecting, setIntersecting] = useState(false);
  const [isHasView, setIsHasView] = useState(false);

  const observer = new IntersectionObserver(
    ([entry]) => {
      setIntersecting(entry.isIntersecting);
      if (entry.isIntersecting) {
        setIsHasView(entry.isIntersecting);
      }
    },
  );

  useEffect(() => {
    observer.observe(ref.current);
    return () => { observer.disconnect(); };
  }, []);

  return {
    isHasView,
    isIntersecting,
  };
};

export default useIntersection;
